<template>
  <pop-up-layout 
    :title="$t('reservas.listas.cambiarFecha')"
    :description="$t('reservas.listas.cambioFechaTexto', {reserva: reserva.inmueble_descripcionLarga})"
    :aceptar="$t('reservas.listas.cambiar')"
    :saving="waitingForLoad"
    :disabled="!changed"
    @volver="$parent.hide()"
    @aceptar="cambiarEstado()"
  >
    <v-layout row justify-center mb-3>
      <v-flex xs10 sm7 md6>
        <o-date-picker
          :label="$t('reservas.listas.nuevaFechaCaducidad')"
          hide-details
          v-model="auxFechaLimite"
        />
      </v-flex>
    </v-layout>
  </pop-up-layout> 
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: ['reserva'],
  data () {
    return {
      waitingForLoad: false,
      mostrarConfirmar: false,
      auxFechaLimite: null,
      changed: false,
      unwatch: null
    }
  },
  created () {
    this.auxFechaLimite = this.reserva.fechaLimite
    this.unwatch = this.$watch('auxFechaLimite', this.auxFechaLimiteWatch)
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  beforeDestroy () {
    this.$emit('cambiado', false)
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  methods: {
    ...mapActions({
      modificar: 'reservas/modificar',
      addAlert: 'alerts/add'
    }),
    alertPreRefresh (e) {
      if (this.changed) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    async cambiarEstado () {
      try {
        this.waitingForLoad = true
        this.$parent.noCerrarInterno = true
        await this.modificar({id: this.reserva.id, fechaLimite: this.auxFechaLimite})
        this.$emit('recargar', true)
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        this.addAlert({texto: this.$t('reservas.listas.fechaLimite'), color: 'success'})
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    auxFechaLimiteWatch (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.changed = true
        this.$emit('cambiado', this.changed)
        this.unwatch()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reservas/listas/PopUpCambiarEstado.vue